import React from "react";
import Logo from '../images/bharat blade final1.png'

function Home() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: '20px',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '60px 40px',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          maxWidth: '600px',
          width: '100%',
        }}
      >
        <div
         
        >
          <img  style={{
            // fontSize: '64px',
            marginbottom: '20px',
            width: '250px',
            height: '200px'
          }} src={Logo} alt="" />
        </div>

        <h1
          style={{
            fontSize: '48px',
            fontWeight: 'bold',
            color: '#1a202c',
            margin: '0',
            lineHeight: '1.2',
          }}
        >
          Coming Soon
        </h1>

        <p
          style={{
            fontSize: '18px',
            color: '#4a5568',
            marginBottom: '32px',
            lineHeight: '1.6',
            fontWeight: '500',
          }}
        >
          Website is under construction. Stay tuned for something amazing!
        </p>

        <div
          style={{
            // paddingTop: '32px',
            borderTop: '2px solid #e2e8f0',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              color: '#718096',
              marginBottom: '8px',
            }}
          >
            For inquiries:
          </p>
          <a
            href="mailto:bharatbladecharters@gmail.com"
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#667eea',
              textDecoration: 'none',
              transition: 'color 0.3s ease',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#764ba2')}
            onMouseLeave={(e) => (e.target.style.color = '#667eea')}
          >
            bharatbladecharters@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
